import { type FunctionComponent } from 'react';
import { formatPrice } from '../../../../helpers/general-helper/general-helper';
import { InternalPriceTooltip, type InternalPriceTooltipProps } from '../../../internal-price-tooltip/internal-price-tooltip.component';
import { PriceRange, type PriceRangeProps } from '../../../product-components/product-price/price-range/price-range.component';

export type PriceProps = {
	unitPrice?: number;
	discountUnitPrice?: number;
	quantity?: number;
	units?: string;
	totalPriceClassName?: string;
	alignRight?: boolean;
	startingAt?: boolean;
	overridePriceMessage?: string;
	internalPriceTooltipProps?: InternalPriceTooltipProps;
	priceRange?: PriceRangeProps;
};

export const Price: FunctionComponent<PriceProps> = ({
	unitPrice = 0,
	discountUnitPrice = 0,
	quantity = 1,
	units,
	totalPriceClassName = 'f5 font-medium',
	alignRight,
	startingAt = false,
	overridePriceMessage,
	internalPriceTooltipProps,
	priceRange
}) => {
	const hasValidDiscount = discountUnitPrice > 0 && unitPrice > discountUnitPrice;
	const actualUnitPrice = hasValidDiscount ? discountUnitPrice : unitPrice;
	return (
		<>
			<div className={`flex items-baseline ${alignRight ? 'justify-end' : ''}`}>
				<div className={totalPriceClassName}>
					{overridePriceMessage ?? (
						<>
							{priceRange ? (
								<PriceRange
									min={priceRange.min}
									max={priceRange.max}
									squareFootageBased={priceRange.squareFootageBased}
									className={priceRange.className}
								/>
							) : (
								<>
									{startingAt && 'Starting at '}
									{formatPrice(actualUnitPrice * quantity)}
									{units && <> / {units}</>}
									{hasValidDiscount && (
										<span className="f6 strike theme-grey normal ml2">{formatPrice(unitPrice * quantity)}</span>
									)}
								</>
							)}
						</>
					)}
				</div>
				{internalPriceTooltipProps && (
					<div className="dib ml2">
						<InternalPriceTooltip {...internalPriceTooltipProps} />
					</div>
				)}
			</div>
		</>
	);
};
